import RouteUtils from '~/core/utils/RouteUtils';
import {policyWagesDeclarationPaths} from '~/paths';

const routes = [
	{
		path: policyWagesDeclarationPaths.preliminaryInfo,
		title: 'Wages Declaration - Policy Info',
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/PolicyInformationPage');
		}),
	},
	{
		path: policyWagesDeclarationPaths.businessDetails,
		title: 'Wages Declaration - Wage Declaration ',
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/WageDeclarationPage');
		}),
	},
	{
		path: policyWagesDeclarationPaths.thankYou,
		title: 'Wages Declaration - Thank You',
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/ThankYouPage');
		}),
	},
];

export default routes;
